<template>
    <v-card style="" class="pb-3 pt-0 px-2 account-callback-requests">
    <div v-if="contactUsRequests.length">
        <v-card class="pb-4 pt-2 px-3 my-3" v-for="(request, index) in contactUsRequests">
            <v-layout
                row
                class="px-3 pb-1 pt-3">
                <div class="font-weight-medium mr-2 width-200">

                    Date:
                </div>
                <div>
                    {{ request.received | time }}
                </div>
            </v-layout>
            <v-layout
                row
                class="px-3 py-1" v-if="request.email">
                <div class="font-weight-medium mr-2 width-200">

                    Email:
                </div>
                <div>
                    {{ request.email }}
                </div>
            </v-layout>
            <v-layout
                row
                class="px-3 py-1" v-if="request.phone">
                <div class="font-weight-medium mr-2 width-200">

                    Phone:
                </div>
                <div>
                    {{ formatPhoneNumber(request.phone) }}
                </div>
            </v-layout>
            <v-layout
                row
                class="px-3 py-1">
                <div class="font-weight-medium mr-2 width-200">
                    Category:
                </div>
                <div>
                    {{ request.category }}
                </div>
            </v-layout>
            <v-layout
                v-if="request.message"
                row
                class="px-3 py-1">
                <div class="font-weight-medium mr-2 width-200">
                    Message:
                </div>
                <div>
                    {{ request.message }}
                </div>
            </v-layout>
            <!-- <v-divider class="pb-2 mt-2" v-if="index + 1 < contactUsRequests.length" :key="index">

            </v-divider> -->
        </v-card>
    </div>
</v-card>
</template>
<script>
import { formatPhoneNumber } from "../../utils/helpers.js";
export default {
    props: {
        contactUsRequests: Array,
    },
    data() {
        return {
        };
    },
    watch: {
    },
    async created() {
    },
    mounted() {},
    beforeDestroy() {},
    computed: {},
    methods: {
        formatPhoneNumber(number) {
            return formatPhoneNumber(number);
        }
    },
};
</script>
<style>
</style>
